
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const ArrowExportUp20Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 20 20" width={20} height={20} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="M9.65 2.15c.2-.2.5-.2.7 0l4 4a.5.5 0 0 1-.7.7L10.5 3.71V14.5a.5.5 0 0 1-1 0V3.7L6.35 6.86a.5.5 0 1 1-.7-.7l4-4ZM4 17.5c0-.28.22-.5.5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Z"
            fill="currentColor"
        />
    </svg>
}